import firebase from "firebase/app"

import config from "../configAccra.json"

export const initializeMyFirebase = () => {
  if (!firebase.apps.length) {
    firebase.initializeApp(config)
  }
}

export const askForPermissioToReceiveNotifications = async () => {
  try {
    const messaging = firebase.messaging()

    await messaging.requestPermission()
    // const token = await messaging.getToken();

    // return token
  } catch (error) {
    console.error(error)
  }
}
